import { LogicOperator } from '@transcend-io/privacy-types';

import type { Schema, SchemaField, SchemaToType } from '@main/schema-utils';
import { mkInput } from '@main/schema-utils';

import { AssessmentRuleInput } from './assessmentRule';

export const AssessmentLogicInput = mkInput({
  name: 'AssessmentLogicInput',
  comment: 'Input for adding logic to an assessment trigger configuration',
  fields: {
    logicOperator: {
      comment: 'The operator to use when comparing the rules',
      type: { LogicOperator },
    },
    rules: {
      comment:
        'The rules to evaluate and be compared with each other using the logic operator',
      type: AssessmentRuleInput,
      list: true,
      optional: true,
    },
    nestedLogics: {
      comment:
        'The nested logics to add one more level of nesting to the logic.',
      // Typescript needed some help inferring the type here, due to the recursive nature of the schema
      type: (): Schema<
        'AssessmentLogicInput',
        {
          /** The operator to use when comparing the nested rules */
          logicOperator: SchemaField;
          /** The rules to evaluate and be compared with to other using the LogicOperator */
          rules?: SchemaField;
          /** The nested logics to add one more level of nesting to the logic. */
          nestedLogics?: SchemaField;
        },
        'input',
        false,
        false
      > => AssessmentLogicInput,
      list: true,
      optional: true,
    },
  },
});

/** Override type */
export type AssessmentLogicInput = SchemaToType<typeof AssessmentLogicInput>;
